import React, { useState, useEffect} from "react";
import ShoppingCart from "./shoppingcart";
import partsService from "../../services/partsservice";
import { useDispatch, useSelector } from "react-redux";
import { selectors as headerSelector, operations as headeroperations } from "../../state/features/header";
import { selectors as globalDataSelector, operations as commondataoperations } from "../../state/features/common/globaldata";
import helperfunctions from "../../utils/helperfunctions";
import machineservice from "../../services/machineservice";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../const/resource";
import { confirmDailog } from "../ConfirmDailog";
import { useSearchParams } from "react-router-dom";
import { CARDTYPE, PAYMENTMETHOD } from "../../const/enum";
import FleetService from "../../services/fleetservice";
import { toast } from 'react-toastify';
import {
    selectors as orderSelector,
    operations as orderoperations
} from "../../state/features/orderdetail";
import { IAppContextProps } from "../App/AppInterface";
import { useAppContext } from "../App/App";

function ShoppingCartContainer(props: any) {
    const { t } = useTranslation();
    const [cartToolMenu, setcartToolMenu] = useState(true);
    const [partsListItems, setPartsListItems] = useState<any>([]);
    const [isMaintenancePartLoading, setIsMaintenancePartLoading] = useState<any>(false);
    const [isPunchOutUser, setIsPunchOutUser] = useState(false);
    const [punchoutButtonVisibility, setPunchoutButtonVisibility] = useState<boolean>(false);
    const [komatsuCreditHistoryButtonVisibility, setKomatsuCreditHistoryButtonVisibility] = useState<boolean>(false);
    const [isDropshipEnable, setIsDropshipEnable] = useState<boolean>(false);
    const [mvcPunchoutHistoryUrl, setMvcPunchoutHistoryUrl] = useState<any>("");
    const { headercurrentuser: { azureADId } }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));

    const { myKomatsuBaseUrl }: any = useSelector((state) => ({
        myKomatsuBaseUrl: headerSelector.myKomatsuBaseUrl(state),
    }));

    const { globalData, headercurrentuser }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
        headercurrentuser: headerSelector.currentuser(state),
    }));

    const initialValues = {
        manufacturer: {},
        machine: {},
        partNumber: "",
        childPartNumber: "",
        cartDetailId: ""
    };
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [quantityChange, setQuantityChange] = useState<any>(false);
    const [selectedBookmarkItem, setSelectedBookmarkItem] = useState<any>([]);
    const [machineManufactureModel, setMachineManufactureModel] = useState<any>(initialValues);
    const [cartsDetails, setCartDetails] = useState<any>({});
    const [productRecommendationPopup, setProductRecommendationPopup] = useState(false);
    const [manufacturePopup, setManufacturePopup] = useState(false);
    const [machinePopup, setMachinePopup] = useState(false);
    const [isMachine, setIsMachine] = useState(false);
    const [isPartNumber, setIsPartNumber] = useState(false);
    const [childCheckboxes, setChildCheckboxes] = useState<any>([]);
    const [manufactureOption, setManufactureOption] = useState<any>([]);
    const [machineOption, setMachineOption] = useState<any>([]);
    const [machineOptionList, setMachineOptionList] = useState<any>([]);
    const [maintenancePartsList, setMaintenancePartsList] = useState<any>([]);
    const [maintenancePartModel, setMaintenancePartModel] = useState<any>("");
    const [maintenancePartSerial, setMaintenancePartSerial] = useState<any>("");
    const [cartItem, setCartItem] = useState<any>(null);
    const [bookmarkItems, setBookmarkItems] = useState<any>([]);
    const [partsListItemsGrid, setPartsListItemsGrid] = useState<any>([]);
    const [listType, setListType] = useState<any>("Both");
    const [itemSummaryDetails, setItemSummaryDetails] = useState({ loading: false, data: {} });
    const [isFetchingCartItems, setIsFetchingCartItems] = useState(false);
    const [isDisableNext, setIsDisableNext] = useState(true);
    const [openSavePartList, setOpenSavePartList] = useState(false);
    const page = searchParams?.get("page");
    const [refreshCartRequiredParts, setRefreshCartRequiredParts] = useState<any[]>([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [stepperDetails, setStepperDetails] = useState<any>({});
    const [saveShipmentDetailsRes, setSaveShipmentDetailsRes] = useState({ loading: false, data: {} });
    const [placeOrderRes, setPlaceOrderRes] = useState({ loading: false, data: {} });
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [isFetchingPartsListItems, setIsFetchingPartsListItems] = useState(false);
    const [savePaymentDetailsRes, setSavePaymentDetailsRes] = useState({ loading: false, data: {} });
    const [stepStatus, setStepStatus] = useState({ 1: 'waiting', 2: 'waiting', 3: 'waiting' })
    const [clearCartCheckOutDatarRes, setClearCartCheckOutDatarRes] = useState({ loading: false, data: {} })
    const [isPunchOutDistributorUser, setIsPunchOutDistributorUser] = useState(false);
    const [isPlaceOrderButton, setIsPlaceOrderButton] = useState(false);
    const [availabilityDetails, setAvailabilityDetails] = useState({ loading: false, data: {} });
    const [customerCreditInfo, setCustomerCreditInfo] = useState<any>({ loading: false, data: {} });
    const [isPartAdded, setIsPartAdded] = useState(false);
    const [isStepOneLoadingCompleted, setIsStepOneLoadingCompleted] = useState(true);
    const { isMiningDistributor, isMixedFleetDistributor, isWacMixedFleetDistributor }: IAppContextProps = useAppContext();
    const [miningParts, setMiningParts] = React.useState<any>({ loading: false, data: [] });

    const [distributorContactsInfo, setDistributorContactsInfo] = useState<any>({});
    const [isCartListLoading, setIsCartListLoading] = useState<boolean>(false);
    const dispatchDropshipFlag = orderoperations.dispatchEnableDropshipFlag(dispatch);
    const dispatchEnablePartOrdering = orderoperations.dispatchEnablePartOrdering(dispatch);
    const dispatchEnableOrderTracking = orderoperations.dispatchEnableOrderTracking(dispatch);
    const dispatchReturnableFlag = orderoperations.dispatchReturnableFlag(dispatch);
    const [showCreditWarningMsg, setShowCreditWarningMsg] = useState<any>(false);
    const {
        enableDropshipFlag,
        enableOrderTracking,
        showReturnableFlag
    }: any = useSelector((state) => ({
        enableDropshipFlag: orderSelector.enableDropshipFlag(state),
        enableOrderTracking: orderSelector.enableOrderTracking(state),
        showReturnableFlag: orderSelector.showReturnableFlag(state)
    }));
    const dispatchCartCount = headeroperations.dispatchCartCount(dispatch);
    const dispatchsetGlobalData = commondataoperations.dispatchCurrentGlobalData(dispatch);

    useEffect(() => {
        if (isMiningDistributor && !isWacMixedFleetDistributor) {
            const paths = ['/shoppingcart', '/shoppingcart/quotes', '/shoppingcart/punchouthistory', '/shoppingcart/savedpartslist', '/shoppingcart/komatsucredithistory'];
            const redirectUrl = '/myfleet';
            if (paths.includes(location.pathname.toLowerCase())) {
                window.location.href = redirectUrl;
            }
        }
    }, [isMiningDistributor]);

    const getCartItems = (isRefresh = false, isShowWarning = false) => {
        updateAndRefreshCart("Update", isRefresh, isShowWarning);
    }

    const getCartItemsAndRefreshCart = () => {
        setIsCartListLoading(true);
        updateAndRefreshCart("Refresh");
    }

    const removeDuplicates = (data: any) => {
        let uniq: any = {};
        return data.filter((obj: any) => !uniq[obj.mDbId] && (uniq[obj.mDbId] = true))
    }

    const updateIsPartAddedStatus = (flg: boolean = false) => {
        setIsPartAdded(flg);
    }

    const GetMVCPunchoutHistoryUrl = () => {
        fetch("/auth/GetMVCPunchoutHistoryUrl")
            .then((response) => response.json())
            .then((result) => {
                setMvcPunchoutHistoryUrl(result.mvcPunchoutHistoryUrl);
            })
            .catch(() => {
            });
    };

    const GetDropshipEnabled = () => {
        fetch("/auth/GetDropshipEnabled")
            .then((response) => response.json())
            .then((result) => {
                setIsDropshipEnable(result?.dropshipEnabled ?? false);
                if (!result?.dropshipEnabled) {
                    GetMVCPunchoutHistoryUrl()
                }
            })
            .catch(() => {
            });
    }

    useEffect(() => {
        const machinePartList = cartsDetails?.parts?.map((t: any) => t.machine) ?? [];
        const substitutePartsList = cartsDetails?.parts?.map((t: any) => t.substituteParts)?.reduce(function (a: any, b: any) {
            return a.concat(b);
        }, []) ?? [];
        const substituteMachinePartList = substitutePartsList?.map((t: any) => t.machine) ?? [];
        const machineData = machinePartList.concat(substituteMachinePartList);
        const machineOpt = removeDuplicates(machineData ?? []);
        const defaultIds = machineOptionList?.map((t: any) => t.value) ?? [];
        const option = machineOpt?.filter((x: any) => x.mDbId != 0 && defaultIds.indexOf(`${x.mDbId}`) == -1)?.map((t: any) => ({ title: t.model, value: t.mDbId, model: t.model, serial: t.serial, unit: t.unitNumber })) ?? [];
        const finalOptionList = machineOptionList.concat(option);
        setMachineOption(finalOptionList ?? []);

    }, [cartsDetails])

    const getCustomerCreditInfo = async (customerId: number, IsFetchingCart = false) => {
        try {
            const userRoleType = headercurrentuser?.usertype?.name?.toLowerCase() ?? "customer";
            const isDistributorAdmin = headercurrentuser?.userClaims?.includes("Administration-Distributor-AdminRole");
            const isPartsCreditEnabled = (userRoleType === 'customer' || (userRoleType === 'distributor' && isDistributorAdmin) || userRoleType === 'employee' || userRoleType === 'company');
            if (isPartsCreditEnabled) {
                setCustomerCreditInfo({ loading: true, data: {} });
                const req = {
                    customerId,
                    cartId: cartsDetails?.cart?.cartId ?? 0,
                    userAadId: headercurrentuser?.azureADId,
                }
                const response = await partsService.getCustomerCreditInfo(req);
                if (response?.isSuccess) {
                    setKomatsuCreditHistoryButtonVisibility((response?.data?.totalCredit ?? 0) > 0);
                    setCustomerCreditInfo({ loading: false, data: response?.data ?? {} });
                    if (IsFetchingCart) {
                        setIsFetchingCartItems(false);
                    }
                } else {
                    setKomatsuCreditHistoryButtonVisibility(false);
                    setCustomerCreditInfo({ loading: false, data: {} });
                    if (IsFetchingCart) {
                        setIsFetchingCartItems(false);
                    }
                    if (response?.msg?.trim() != 'Not Found') {
                        helperfunctions.showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_Promo_GetCustomerCreditInfo_Error_Msg)} - ${response?.msg}`);
                    }
                }
            } else {
                if (IsFetchingCart) {
                    setIsFetchingCartItems(false);
                }
            }
        } catch (error) {
            setKomatsuCreditHistoryButtonVisibility(false);
            setCustomerCreditInfo({
                loading: false, data: {}
            });
            if (IsFetchingCart) {
                setIsFetchingCartItems(false);
            }
        }
    };

    const getCustomerId = () => {
        return globalData?.CustomerId ? parseInt(globalData?.CustomerId) : 0;
    }

    const checkCartBranchAndSelectedBranch = (response: any) => {
        return (globalData?.BranchCode && (globalData?.BranchCode != response.cart.branchCode) || (globalData?.DistributorCode != response.cart.distributorCode) ||
            (String(globalData?.CustomerId) != String(response.cart.customerId)) || (String(globalData?.LocationId) != String(response.cart.locationId)))
    }

    const setDefaultCartMenu = (item: any, response: any) => {
        if (item == "Refresh") {
            setcartToolMenu(response?.parts?.length > 0 ? true : false);
        }
    }

    const updateCartCountAndItemSummary = (item :any) => {
        if (item == "Update") {
            updateCartCount();
            setItemSummaryDetails({ loading: false, data: {} })
        }
    }

    const clearPartsCredit = (cartId : any = 0) => {
        if (cartId  > 0) {
            partsService.clearPartsCredit(cartId, headercurrentuser?.azureADId)
                .then(() => {})
        }
    }

    const updateCartAfterResponse = (item: any, response: any, isRefresh: any, isShowWarning: any) => {
        setChildCheckboxes(response?.parts?.reduce((acc: any, child: any) => {
            acc[child.cartDetailId] = false;
            return acc;
        }, {}) ?? []);
        let cartresponse = response ?? {};
        if (checkCartBranchAndSelectedBranch(response)) {
            let model = response;
            if (model.cart.customerId != getCustomerId()) {
                clearPartsCredit(response?.cart?.cartId);
            }
            model.cart.branchCode = globalData?.BranchCode;
            model.cart.distributorCode = globalData?.DistributorCode;
            model.cart.customerId = globalData?.CustomerId;
            model.cart.locationId = globalData?.LocationId;
            updateCartCountAndItemSummary(item);
            updateCartItemWithBranchAndDistributor(model);
            setCartDetails(cartresponse);
            setDefaultCartMenu(item, response);
        }
        else {
            setCartDetails(cartresponse);
            updateCartCount();
            if ((response?.cart?.cartId ?? "") != "") {
                if (item == "Refresh") {
                    clearCartCheckOutData(response?.cart?.cartId);
                    refreshWithCartId(response?.cart?.cartId, isRefresh, response?.cart?.isRestrictPartsCheck);
                }
                if (item == "Update") {
                    setIsCartListLoading(false);
                    getItemSummaryDetails(response, isShowWarning, true);
                }
            }
            else if (item == "Update") {
                setIsCartListLoading(false);
                setIsFetchingCartItems(false);
                setItemSummaryDetails({ loading: false, data: {} });
            }
        }
        if (globalData?.isAvailabilityRefresh) {
            getAvailabilityDetails(globalData?.isAvailabilityRefresh);
        }
    }


    const getMiningParts = () => {
        if (isMixedFleetDistributor || isWacMixedFleetDistributor) {
            partsService.getMiningPartsList(headercurrentuser?.azureADId).then((response: any) => {
                setMiningParts({ loading: false, data: response??[] });
            }).catch(() => {
                setMiningParts({ loading: false, data: [] });
            })
        }
    }

    const updateAndRefreshCart = (item: string, isRefresh = false, isShowWarning = false) => {
        setIsFetchingCartItems(true);
        partsService.getPartsList(azureADId, globalData?.punchOutRequestPartLogId ?? 0)
            .then((response: any) => {
                if (isRefresh) {
                    setRefreshCartRequiredParts([]);
                }
                if (globalData.CustomerId) {
                    const customerId = getCustomerId();
                    getCustomerCreditInfo(customerId);
                }
                setIsFetchingCartItems(false);
                if (response?.cart) {
                    if (isNewPartAdded(response)) {
                        isRefresh = true;
                    }
                    updateCartAfterResponse(item, response, isRefresh, isShowWarning);
                }
                else {
                    setIsCartListLoading(false);
                }
            })
            .catch((e: any) => {
                setIsCartListLoading(false);
                setIsFetchingCartItems(false);
                if (isRefresh) {
                    setRefreshCartRequiredParts([]);
                }
            });
    }

    const updateCartCount = () => {
        machineservice.getCartCount().then((response: any) => {
            dispatchCartCount({ result: response });
        }).catch((error: any) => {
            console.log(error);
        });
    }

    useEffect(() => {
        if (globalData?.CustomerId && globalData?.CustomerId != "") {
            getPartsOrderingFlag();
        }
    }, [globalData?.CustomerId])

    const getPartsOrderingFlag = () => {
        partsService.getPartsOrderingFlag(globalData?.CustomerId)
            .then((response: any) => {
                dispatchEnablePartOrdering({ enablePartOrdering: response });
            })
            .catch((e: any) => {
                dispatchEnablePartOrdering({ enablePartOrdering: false });
            });
    }

    const getAdminFlag = () => {
        if (globalData?.DistributorCode) {
            partsService.getDropshipOtReturnableFlag(globalData?.DistributorCode)
                .then((response: any) => {
                    dispatchDropshipFlag({ enableDropshipFlag: response?.isDropShipEnabledFlag });
                    dispatchReturnableFlag({ showReturnableFlag: response?.isReturnableEnabledFlag });
                    dispatchEnableOrderTracking({ enableOrderTracking: response?.isOTEnabledFlag });
                })
                .catch((e: any) => {
                    dispatchDropshipFlag({ enableDropshipFlag: false });
                    dispatchReturnableFlag({ showReturnableFlag: false});
                    dispatchEnableOrderTracking({ enableOrderTracking: false});
                });
        }
    }

    function isNewPartAdded(response: any) {
        let isNewPartAdded = false;
        if (response?.parts?.length > 0) {
            if (response?.parts?.some((part: any) => part.partLastRefreshed == "0001-01-01T00:00:00" && (part.isValidKomatsuProduct !== false && part.isValidKomatsuProduct !== true)) ) {
                isNewPartAdded = true;
            }
        }
        return isNewPartAdded;
    }

    const checkBranchandDistributor = () => {
        return ((globalData?.BranchCode ?? "") != "" && (globalData?.DistributorCode ?? "") != "" &&
            (((globalData?.CustomerId ?? "") != "" && (globalData?.LocationId ?? "") != "" && globalData?.BranchName)) || headercurrentuser?.isGuestUser);
    }

    const getMachineManufacturePunchoutButton = (branchCode : any = null) => {
        clearMachineManufacturePunchoutButton();
        getPunchoutButtonVisibility(branchCode);
        getManufactureList(branchCode);
        getMachineList();
    }

    const clearMachineManufacturePunchoutButton = () => {
        setPunchoutButtonVisibility(false);
        setManufactureOption([]);
        setMachineOption([]);
    }

    useEffect(() => {
        if (checkBranchandDistributor()) {
            if (!isCartListLoading) {
                if (cartsDetails?.cart != null) {
                    if (cartsDetails.cart?.customerId != getCustomerId()) {
                        clearPartsCredit(cartsDetails?.cart?.cartId);
                    }
                    cartsDetails.cart.branchCode = globalData?.BranchCode;
                    cartsDetails.cart.distributorCode = globalData?.DistributorCode;
                    cartsDetails.cart.customerId = globalData?.CustomerId;
                    cartsDetails.cart.locationId = globalData?.LocationId;
                    setIsCartListLoading(true);
                    updateCartItemWithBranchAndDistributor(cartsDetails);
                }
                else {
                    setCartDetails({});
                    getCartItemsAndRefreshCart();
                }
            }
            setChildCheckboxes([]);
            if (headercurrentuser?.isGuestUser) {
                getMachineManufacturePunchoutButton();
                getAdminFlag();
            }
            setItemSummaryDetails({ loading: false, data: {} })
        }
        else {
            setCartDetails({});
            setChildCheckboxes([]);
            setItemSummaryDetails({ loading: false, data: {} });
        }
    }, [globalData?.BranchCode])

    const getPunchoutButtonVisibility = (branchCode :any = null) => {
        const model = {
            customerId: globalData?.CustomerId,
            locationId: globalData?.LocationId,
            distributor2: branchCode ?? globalData?.BranchCode,
            distributor4: globalData?.DistributorCode,
            userAadId: headercurrentuser?.azureADId
        }

        partsService.getPunchoutButtonVisibility(model).then((response: any) => {
            setPunchoutButtonVisibility(response?.canShowPunchoutHistory ?? false)
        }).catch(() => {
            setPunchoutButtonVisibility(false)
        })
    }

    const CheckPunchOutDistributor = async (distributorId: any) => {
        try {
            const response = await partsService.checkPunchOutDistributor(distributorId);
            if (response?.isSuccess) {
                setIsPunchOutDistributorUser(response?.data?.isPunchoutDistributor);
            } else {
                setIsPunchOutDistributorUser(false);
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setIsPunchOutDistributorUser(false);
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    useEffect(() => {
        if (page == 'savepartsList') {
            setOpenSavePartList(true);
        }
        GetDropshipEnabled();
    }, []);

    useEffect(() => {
        const distributorId = globalData?.DistributorId ? parseInt(globalData?.DistributorId) : 0;
        if (distributorId) {
            CheckPunchOutDistributor(distributorId)
        }
    }, [globalData?.DistributorId]);

    useEffect(() => {
        const distributorCode = globalData?.DistributorCode;
        if (distributorCode != "" && distributorCode != null) {
            loadDistributorContacts();
        }
    }, [globalData?.DistributorCode]);


    const loadDistributorContacts = () => {
        FleetService.getDistributorContacts(headercurrentuser?.azureADId, globalData?.DistributorCode)
            .then((response: any) => {
                setDistributorContactsInfo(response);
            }).catch((e) => {
                setDistributorContactsInfo({});
            });
    }

    const getManufactureList = (branchCode :any = null) => {
        partsService.getManufactureList(globalData.DistributorCode, branchCode??globalData.BranchCode)
            .then((response: any) => {
                const option = response?.map((t: any) => ({ title: t.manufacturerName, value: t.manufacturerCode })) ?? [];
                const sortedData = option?.slice().sort((a: any, b: any) => a.title.localeCompare(b.title));
                setManufactureOption(sortedData);
            })
            .catch((e: any) => {
            });
    }

    const getMachineList = () => {
        if (!headercurrentuser?.isGuestUser) {
            const data = {
                userAadId: azureADId,
                distributor4Code: globalData?.DistributorCode,
                customerId: globalData?.CustomerId,
                locationId: globalData?.LocationId,
            }

            partsService.getMachineListForShoppingCart(data)
                .then(async (response: any) => {
                    const option = response?.map((t: any) => ({ title: helperfunctions.getMachineTitle(t.model, t.serial, t.unit), value: t.machineId, model: t.model, serial: t.serial, unit: t.unit })) ?? [];
                    setMachineOptionList(option);
                })
                .catch((e: any) => {
                });
        }
    }

    const partNumberRedirect = (partsNumber: any) => {
        let partsStoreUrl = headercurrentuser?.isGuestUser ? `/guestecommerce/Index?partNumber=${partsNumber}`:`/ECommerce/Index?partNumber=${partsNumber}`;
        window.location.href = `${myKomatsuBaseUrl}${partsStoreUrl}`;
    }

    const handleParentChange = () => {
        setChildCheckboxes((prevState: any) => {
            const updatedCheckboxes = { ...prevState };
            for (const key in updatedCheckboxes) {
                updatedCheckboxes[key] = true;
            }
            return updatedCheckboxes;
        });
    };

    const handleChildChange = (childId: any) => {
        setChildCheckboxes((prevState: any) => {
            const updatedCheckboxes = { ...prevState };
            updatedCheckboxes[childId] = !updatedCheckboxes[childId];
            return updatedCheckboxes;
        });
    };

    const handleDeselectAll = () => {
        setChildCheckboxes((prevState: any) => {
            const updatedCheckboxes = { ...prevState };
            for (const key in updatedCheckboxes) {
                updatedCheckboxes[key] = false;
            }
            return updatedCheckboxes;
        });
    };

    const productRecommendationPopupClick = (cart_Item: any) => {
        setCartItem(cart_Item);
        setProductRecommendationPopup(!productRecommendationPopup);
        updateIsPartAddedStatus(false);
    };

    const toggleManufacturePopupClick = () => {
        setManufacturePopup(!manufacturePopup);
    };

    const toggleMachinePopupClick = () => {
        setMachinePopup(!machinePopup);
        setIsMachine(!isMachine);
    };

    const onHandlePartNo = () => {
        setIsPartNumber(!isPartNumber);
    };

    const refreshWithCartId = (cartId: any, isRefresh: boolean = false, isRestrictParts: boolean = false) => {
        const model = {
            cartId: cartId,
            userAadId: azureADId,
            punchOutRequestPartLogId: globalData?.punchOutRequestPartLogId ?? 0
        }
        setIsFetchingCartItems(true);
        if (isRefresh && isRestrictParts) {
            isRefresh = false;
        }

        if (!isRestrictParts)
        {
            setIsRefreshing(isRefresh);
        }
        partsService.getRefreshPartsList(model, isRefresh)
            .then((response: any) => {
                if (response?.isSuccessful) {
                    setQuantityChange(false);
                    getCartItems(true, true);
                    localStorage.setItem("isRefreshedAfterAdd", 'true');
                }
                else {
                    if (!isRestrictParts) {
                        helperfunctions.showErrorMessage(response?.message);
                    }
                    setIsFetchingCartItems(false);
                    getCartItems(true, false);
                }
                setRefreshFlag();
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessage(e);
                setRefreshFlag();
                setIsFetchingCartItems(false);
                setRefreshCartRequiredParts([]);
            });
    }

    const setRefreshFlag = () => {
        setTimeout(() => {
            setIsRefreshing(false);
        }, 5000);
    }

    const onRefresh = (checkoutFun: any, isHardRefresh: boolean = false) => {
        const model = {
            cartId: cartsDetails?.cart?.cartId,
            userAadId: azureADId,
            punchOutRequestPartLogId: globalData?.punchOutRequestPartLogId ?? 0
        }
        setIsFetchingCartItems(true);
        if (isHardRefresh && cartsDetails?.cart?.isRestrictPartsCheck) {
            isHardRefresh = false;
        }

        if (!cartsDetails?.cart?.isRestrictPartsCheck) {
            setIsRefreshing(true);
        }
        partsService.getRefreshPartsList(model, isHardRefresh)
            .then((response: any) => {
                if (response?.isSuccessful) {
                    setQuantityChange(false);
                    getCartItems(true, true);
                    localStorage.setItem("isRefreshedAfterAdd", 'true');
                    if (typeof checkoutFun === 'function') {
                        checkoutFun();
                    }
                }
                else {
                    if (!cartsDetails?.cart?.isRestrictPartsCheck) {
                        helperfunctions.showErrorMessage(response?.message);
                    }
                    setIsFetchingCartItems(false);
                    getCartItems(true, false);
                }
                setRefreshFlag();
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessage(e);
                setIsFetchingCartItems(false);
                setRefreshFlag();
                setRefreshCartRequiredParts([]);
            });
    }

    const updateCartQuantity = (cartDetailId: any, partNumber: any, childPartNumber: any, quantity: any, prevQuatity: any) => {
        let refreshCartList = refreshCartRequiredParts;
        if (!refreshCartRequiredParts.includes(cartDetailId) && (quantity !== prevQuatity)) {
            refreshCartList.push(cartDetailId);
            setRefreshCartRequiredParts(refreshCartList);
        }

        if (quantity !== prevQuatity) {
            updateParts(cartDetailId, partNumber, childPartNumber, quantity);
        }
    }

    const updateParts = (cartDetailId: any, partNumber: any, childPartNumber: any, quantity: any) => {
        const parts = cartsDetails?.parts?.map((item: any) => {
            if (item.partNumber == partNumber && childPartNumber) {
                return {
                    ...item,
                    substituteParts: item?.substituteParts?.map((child: any) => {
                        if (child.parentPartNumber == partNumber && child.partNumber == childPartNumber) {
                            return {
                                ...child,
                                quantity: quantity,
                            };
                        }

                        else {
                            return child;
                        }
                    })
                };
            }
            else if (item.partNumber == partNumber && item.cartDetailId == cartDetailId && !childPartNumber) {
                return {
                    ...item,
                    quantity: quantity,
                };
            }
            else {
                return item;
            }
        });
        setCartDetails((prevState: any) => ({ ...prevState, parts: parts }));
        const model = {
            cart: cartsDetails?.cart,
            parts: parts
        }
        setQuantityChange(true);
        updateCartItem(model);

    }

    const updateCartItemWithBranchAndDistributor = (model: any) => {
        model.cart.userAadId = azureADId;
        model.cart.isGuest = headercurrentuser?.isGuestUser;
        if (model?.parts?.length > 0) {
            partsService.updateCartItem(model)
                .then((response: any) => {
                    if (!response.isSuccessful) {
                        setIsCartListLoading(false);
                        helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Update_Part_Error_Msg));
                    }
                    else {
                        partsService.getPartsList(azureADId, globalData?.punchOutRequestPartLogId ?? 0)
                            .then((response: any) => {
                                refreshWithCartId(response?.cart?.cartId, true, response?.cart?.isRestrictPartsCheck);
                            })
                            .catch(() => {
                                refreshWithCartId(model?.cart?.cartId, true, model?.cart?.isRestrictPartsCheck);         
                            });
                    }
                })
                .catch((e: any) => {
                    setIsCartListLoading(false);
                    helperfunctions.showErrorMessage(e);
                });
        }
        else {
            setIsCartListLoading(false);
        }
    }

    const updateCartItem = (model: any) => {
        model.cart.userAadId = azureADId;
        model.cart.isGuest = headercurrentuser?.isGuestUser;
        if (model?.parts?.length > 0) {
            partsService.updateCartItem(model)
                .then((response: any) => {
                    if (!response.isSuccessful) {
                        helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Update_Part_Error_Msg));
                    }
                    else {
                        let itemSummary :any = itemSummaryDetails?.data;
                        if (itemSummary?.shippingCost > 0) {
                            getItemSummaryDetailsWithoutLoading();
                        }
                    }
                })
                .catch((e: any) => {
                    helperfunctions.showErrorMessage(e);
                });
        }
    }

    const getPartsListItems = () => {
        if (!headercurrentuser?.isGuestUser)
        {
            const model = {
                userAadId: azureADId,
                listType: "Both",
                distributorCode: globalData?.DistributorCode,
                customerId: globalData?.CustomerId
            }

            partsService.getSavedPartList(model)
                .then((response: any) => {
                    setPartsListItems(response ?? []);
                })
                .catch((e: any) => {
                    helperfunctions.showErrorMessage(e);
                });
        }
    }

    useEffect(() => {
        if ((globalData?.CustomerId ?? "") != "" && (globalData?.LocationId ?? "") != "" && (globalData?.DistributorCode ?? "") != "" && (globalData?.BranchCode ?? "") != "") {
            const timer = setTimeout(() => {
                getMaintenancePartsList()
            }, 2000)
            return () => clearTimeout(timer)
        }
        else {
            setMaintenancePartsList([]);
        }
    },
        [globalData?.BranchCode, maintenancePartModel, maintenancePartSerial])

    useEffect(() => {
        const { isServiceUser } = headercurrentuser ?? {}
        if (isServiceUser || isPunchOutDistributorUser) {
            setIsPunchOutUser(true);
        } else {
            setIsPunchOutUser(false)
        }
    }, [headercurrentuser, isPunchOutDistributorUser]);

    const getMaintenancePartsList = () => {
        const model = {
            model: maintenancePartModel,
            serial: maintenancePartSerial,
            distributorCode: globalData?.DistributorCode,
            customerId: globalData?.CustomerId ? parseInt(globalData?.CustomerId) : 0,
            locationId: globalData?.LocationId ? parseInt(globalData?.LocationId) : 0,
            branchCode: globalData?.BranchCode,
            pType: ""
        };
        setMaintenancePartsList([]);
        setIsMaintenancePartLoading(true);
        partsService.getMaintenancePartsList(model)
            .then((response: any) => {
                setMaintenancePartsList(response ?? []);
                setIsMaintenancePartLoading(false);
            })
            .catch((e: any) => {
                setIsMaintenancePartLoading(false);
                helperfunctions.showErrorMessage(e);
            });
    }

    const getBookmarkItems = () => {
        partsService.getBookmarkList(azureADId)
            .then((response: any) => {
                setSelectedBookmarkItem([]);
                setBookmarkItems(response ?? []);
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessage(e);
            });
    }

    const getPartsListItemsForGrid = () => {
        if (listType) {
            const model = {
                userAadId: azureADId,
                listType: listType,
                distributorCode: globalData?.DistributorCode,
                customerId: globalData?.CustomerId
            }
            setIsFetchingPartsListItems(true);
            partsService.getSavedPartList(model)
                .then((response: any) => {
                    setPartsListItemsGrid(response?.map((t: any) => ({ ...t, checked: false, expanded: false })) ?? []);
                    setIsFetchingPartsListItems(false);
                })
                .catch((e: any) => {
                    helperfunctions.showErrorMessage(e);
                    setIsFetchingPartsListItems(false);
                });
        } else {
            setPartsListItemsGrid([]);
        }
    }

    useEffect(() => {
        if (showCreditWarningMsg && enableDropshipFlag && enableOrderTracking && distributorContactsInfo) {
            let warningMessage = (t(RESOURCE.Myk_Label_SC_Credit_Card_Enabled_CreditLimit_Msg))?.replace("{0}", distributorContactsInfo?.name || "")?.replace("{1}", distributorContactsInfo?.phone || "");
            helperfunctions.showCreditWarningMessage(warningMessage);
            setShowCreditWarningMsg(false);
        }

    }, [distributorContactsInfo, showCreditWarningMsg])

    const getItemSummaryDetails = async (details: any = cartsDetails, isShowWarning = false, isFetchingCart = false) => {
        try {
            setItemSummaryDetails({ loading: true, data: {} });
            const req = {
                cartId: details?.cart?.cartId,
                userAadId: azureADId,
                distributorId: getDistributorId(),
                customerId: globalData?.CustomerId,
                isGuest: headercurrentuser?.isGuestUser
            }
            const response = await partsService.getItemSummaryDetails(req);
            if (response?.isSuccess) {
                if (!headercurrentuser?.isGuestUser && !response?.data?.isCustomerCreditAvailable && isShowWarning && !(response?.data?.isCustomerApplicable ?? false)) {
                    toast.dismiss("creditwarningtoaster");
                    setShowCreditWarningMsg(true);
                }
                if (isFetchingCart) {
                    setIsFetchingCartItems(false);
                }
                setItemSummaryDetails({ loading: false, data: response?.data ?? {} });
            } else {
                setItemSummaryDetails({
                    loading: false, data: {}
                });
                if (isFetchingCart) {
                    setIsFetchingCartItems(false);
                }
                helperfunctions.showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_Promo_GetItemSummaryDetails_Error_Msg)} - ${response?.msg}`);
            }
        } catch (error) {
            setItemSummaryDetails({
                loading: false, data: {}
            });
            if (isFetchingCart) {
                setIsFetchingCartItems(false);
            }
            helperfunctions.showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_Promo_GetItemSummaryDetails_Error_Msg)} - ${error}`);
        }
    };

    const getDistributorId = () => {
        return isNaN(globalData?.DistributorCode) ? parseInt(globalData?.DistributorId) : parseInt(globalData?.DistributorCode);
    }

    const getItemSummaryDetailsWithoutLoading = (callBackFun: any = null) => {
        const req = {
            cartId: cartsDetails?.cart?.cartId,
            userAadId: azureADId,
            distributorId: getDistributorId(),
            customerId: globalData?.CustomerId,
            isGuest: headercurrentuser?.isGuestUser
        }
        partsService.getItemSummaryDetails(req).then((response: any) =>
        {
            if (response?.isSuccess) {
                setItemSummaryDetails({ loading: false, data: response?.data ?? {} });
                if (typeof callBackFun === 'function') {
                    callBackFun();
                }
            }
        });
    };

    const deletePartNumbers = () => {
        const confimObject = {
            title: t(RESOURCE.MyK_Label_SC_Delete_Confirmation),
            message: t(RESOURCE.MyK_Label_SC_Delete_Msg),
            confirmmessage: '',
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_Yes),
                no: t(RESOURCE.MyK_Label_No),
            },
            yesOnclick: () => {
                setIsFetchingCartItems(true);
                const selectedItems = Object.keys(childCheckboxes)?.filter((key: any) => childCheckboxes[key] === true) ?? [];
                let machineIdList: any[] = [];
                let partsNoList: any[] = [];
                cartsDetails?.parts?.filter((s: any) => selectedItems?.indexOf(String(s.cartDetailId)) > -1)?.forEach((item: any) => {
                    if (item.substituteParts?.length > 0) {
                        item.substituteParts.filter((s: any) => s.machine?.mDbId > 0 && machineIdList.indexOf(s.machine?.mDbId) == -1)?.forEach((item: any) =>
                        {
                            machineIdList.push(item.machine.mDbId);
                        });
                    }
                    else if (item?.machine?.mDbId > 0 && machineIdList.indexOf(item.machine?.mDbId) == -1) {
                        machineIdList.push(item.machine.mDbId);
                    }
                    partsNoList.push(item.partNumber);
                });
                const model = {
                    cartId: cartsDetails?.cart?.cartId,
                    userAadId: azureADId,
                    partsNo: partsNoList?.join(","),
                    machineId: machineIdList?.join(","),
                    cartDetailIds: selectedItems?.join(",")
                };
                partsService.deletePartNumbers(model)
                    .then((response: any) => {
                        setIsFetchingCartItems(false);
                        if (response.isSuccessful) {
                            helperfunctions.showSuccessMessage(t(RESOURCE.Myk_Label_ItemsDeletedSuccessfully));
                            getCartItems();
                        }
                        else
                            helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_HealthLabel_Deleted_Error_Message));
                    })
                    .catch((e: any) => {
                        setIsFetchingCartItems(false);
                        helperfunctions.showErrorMessage(t(RESOURCE.MyK_HealthLabel_Deleted_Error_Message));
                    });
            },
            noOnclick: () => {
            },
        }
        confirmDailog(confimObject);
    }

    const getIsNextDisableStatus = (isDisable: boolean) => {
        setIsDisableNext(isDisable);
    }

    const [savedAddressRes, setSavedAddressRes] = useState({ loading: false, data: {} });
    const [shippingMethodsRes, setShippingMethodsRes] = useState({ loading: false, data: {} });
    const [paymentInfoRes, setPaymentInfoRes] = useState({ loading: false, data: {} });

    const getSavedAddressList = async (addressType: string) => {
        try {
            setSavedAddressRes({ loading: true, data: {} });
            const reqBody = {
                customerId: globalData?.CustomerId ?? '',
                addressType: addressType === 'Shipping' ? 0 : 1,
                userAadId: headercurrentuser?.azureADId,
                orderId: 0,
                isGuest: headercurrentuser?.isGuestUser
            }
            const response = await partsService.getSavedAddressList(reqBody);
            if (response?.isSuccess) {
                setSavedAddressRes({ loading: false, data: response?.data ?? {} });
                return response?.data ?? {}
            } else {
                setSavedAddressRes({
                    loading: false, data: {}
                });
                helperfunctions.showErrorMessage(`${response?.msg}`);
                return {}
            }
        } catch (error) {
            setSavedAddressRes({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
            return {}
        }
    }

    const getShippingMethods = async () => {
        try {
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                userAadId: headercurrentuser?.azureADId ?? ''
            }
            setShippingMethodsRes({ loading: true, data: {} });
            const response = await partsService.getShippingMethods(reqBody);
            if (response?.isSuccess) {
                setShippingMethodsRes({ loading: false, data: response?.data ?? {} });
                return response?.data ?? {}
            } else {
                setShippingMethodsRes({
                    loading: false, data: {}
                });
                helperfunctions.showErrorMessage(`${response?.msg}`);
                return {}
            }
        } catch (error) {
            setShippingMethodsRes({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
            return {}
        }
    };

    const [fulfillmentDetailRes, setFulfillmentDetailRes] = useState({ loading: false, data: {} });

    const getFulfillmentDetail = async () => {
        try {
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId,
                userAadId: headercurrentuser?.azureADId ?? '',
            }
            setFulfillmentDetailRes({ loading: true, data: {} });
            const response = await partsService.getFulfillmenPermissionDetails(reqBody);
            if (response?.isSuccess) {
                setFulfillmentDetailRes({ loading: false, data: response?.data ?? {} });
                return response?.data ?? {}

            } else {
                setFulfillmentDetailRes({
                    loading: false, data: {}
                });
                helperfunctions.showErrorMessage(`${response?.msg}`);
                return {}
            }
        } catch (error) {
            setFulfillmentDetailRes({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
            return {}
        }
    };

    const getPaymentInfo = async () => {
        try {
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId,
                userAadId: headercurrentuser?.azureADId ?? '',
            }
            setPaymentInfoRes({ loading: true, data: {} });
            const response = await partsService.getPaymentInfo(reqBody);
            if (response?.isSuccess) {
                return response?.data ?? {}
            } else {
                helperfunctions.showErrorMessage(`${response?.msg}`);
                return {}
            }
        } catch (error) {
            helperfunctions.showErrorMessage(`${error}`);
            return {}
        }
    };

    const getFormatedPhoneNumber = (phone: any, phoneCountryCode: any) => {
        let formattedNumber;
        const digitsOnly = getDigitsOnly(phone);
        if (digitsOnly) {
            formattedNumber = (phoneCountryCode == "+1") ? `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}` : phone;
        }
        return formattedNumber ?? phone;
    }

    const getDigitsOnly = (phone: any) => {
        return phone?.replace(/\D/g, '');
    }

    const getDefaultCountryCode = (phoneNumber: any) => {
        const phoneCode = headercurrentuser?.priCountryCode?.length > 0 ? headercurrentuser?.priCountryCode : "+1";
        return (headercurrentuser?.telephone?.length > 0 && getDigitsOnly(phoneNumber) == getDigitsOnly(headercurrentuser?.telephone)) ?
            (phoneCode) : "";
    }

    const getPhoneCountryCode = (phoneCode: any, phoneNumber: any) =>
    {
        return (phoneCode?.length > 0 ? phoneCode : getDefaultCountryCode(phoneNumber))
    }

    const updateStepOne = async () => {
        setIsStepOneLoadingCompleted(false);
        updateStepperDetails({ ...stepperDetails, fulfillment: {} });
        const fulfillment = await getFulfillmentDetail();
        const { shipping, pickupAvailablePlus, pickup, pickupWillCall_KomatsuShipping } = fulfillment ?? {};
        const isPickupAvailablePlusShipping = pickupAvailablePlus?.shipping?.isSelected;
        const isPickupAvailablePlusAdditionalPickup = pickupAvailablePlus?.additionalPickup?.isSelected
        const shipment = stepperDetails?.shipment
        const { addresses } = await getSavedAddressList('Shipping');
        let selectedAddress = addresses?.find((address: any) => address.isSelected);
        if (!selectedAddress) {
            selectedAddress = addresses?.find((address: any) => address.isDefault)
        }
        const shippingMethods = await getShippingMethods();
        const weatherWarning = await getWeatherWarning(selectedAddress?.postalCode, selectedAddress?.countryCode)
        const selectedMethod = shippingMethods?.shippingMethodDetail?.find((method: any) => method.isSelected === true || method.shippingMethodId == shipment?.shippingMethodId) ?? {};
        const shippingMethodName = selectedMethod?.shippingMethod?.toLowerCase();
        const showShippingMethodWarning = shippingMethodName == "delivery" || shippingMethodName == "dropbox" || shippingMethodName == "freight truck";
        let contactPhoneNum = shipment?.contactPhone ?? headercurrentuser?.telephone;
        const phoneCountryCode = getPhoneCountryCode(shipment?.contactPhoneCountryCode ,contactPhoneNum);
        const shippingPhoneNumber = selectedAddress?.phone ?? headercurrentuser?.telephone;
        const shippingPhoneCountryCode = getPhoneCountryCode(selectedAddress?.phoneCountryCode,shippingPhoneNumber);
        if (contactPhoneNum) {
            contactPhoneNum = getFormatedPhoneNumber(contactPhoneNum, phoneCountryCode)
        }
        if (shippingPhoneNumber) {
            selectedAddress.phone = getFormatedPhoneNumber(shippingPhoneNumber, shippingPhoneCountryCode);
            selectedAddress.phoneCountryCode = shippingPhoneCountryCode;
        }
        updateStepperDetails({
            ...stepperDetails,
            fulfillment: {
                isPickup: pickup?.isSelected,
                isShipping: shipping?.isSelected,
                isPickupAvailable: (pickupAvailablePlus?.isSelected || isPickupAvailablePlusShipping || isPickupAvailablePlusAdditionalPickup),
                isPickupAvailablePlusShipping: isPickupAvailablePlusShipping,
                isPickupAvailablePlusAdditionalPickup: isPickupAvailablePlusAdditionalPickup,
                isPickupWillCallKomatsuShipping: pickupWillCall_KomatsuShipping?.isSelected
            },
            shipment:
            {
                ...selectedAddress, serviceTypeId: shipment?.serviceTypeId,
                contactEmail: shipment?.contactEmail ?? headercurrentuser?.eml,
                contactName: shipment?.contactName ?? headercurrentuser?.dn,
                contactPhone: contactPhoneNum,
                contactPhoneCountryCode: phoneCountryCode,
                shippingCostWarning: shippingMethods?.shippingWarning,
                showShippingMethodWarning: showShippingMethodWarning,
                shippingMethodId: selectedMethod?.shippingMethodId??'',
                ...selectedMethod,
                weatherWarning: weatherWarning?.data?.weatherWarning
            }
        });
        setIsStepOneLoadingCompleted(true);
    }

    const updateStepTwo = async () => {
        updateStepperDetails({ ...stepperDetails, payment: {} })
        const paymentInfo: any = await getPaymentInfo();
        setPaymentInfoRes({ loading: false, data: paymentInfo ?? {} });
        if (paymentInfo?.paymentType) {
            const { addresses } = await getSavedAddressList('Billing');
            if (paymentInfo?.paymentType.toLowerCase() === PAYMENTMETHOD[PAYMENTMETHOD.KC].toLowerCase()) {
                const selectedAddress = addresses?.find((address: any) => address?.addressId === paymentInfo?.billingAddressId);
                updateStepperDetails({
                    ...stepperDetails, payment: {
                        ...selectedAddress,
                        creditCardOption: headercurrentuser?.isGuestUser ? CARDTYPE.NEWCARD : CARDTYPE.EXISTINGCARD,
                        creditCardProfileId: paymentInfo?.creditCardProfileId,
                        paymentMethod: paymentInfo?.paymentType,
                        sameAsShipping: false
                    }
                })
            } else if (paymentInfo?.paymentType.toLowerCase() === PAYMENTMETHOD[PAYMENTMETHOD.AC].toLowerCase()) {
                updateStepperDetails({ ...stepperDetails, payment: { poNumber: paymentInfo?.poNumber, paymentMethod: paymentInfo?.paymentType } })
            } else {
                updateStepperDetails({ ...stepperDetails, payment: { paymentMethod: paymentInfo?.paymentType } })
            }
        }
    }

    const updateStepIndex = async (step: number) => {
        if (currentStep !== step) {
            setCurrentStep(step);
            if (step === 1 && stepStatus?.[step] === 'finished') {
                updateStepOne();
            }
            if (step === 2 && stepStatus?.[step] === 'finished') {
                updateStepTwo();
            }
            if (step === 3) {
                setIsPlaceOrderButton(true);
            } else {
                setIsPlaceOrderButton(false);
            }
        }
    }

    const updateStepperDetails = (data: any, isClear = false) => {
        if (isClear) {
            setStepperDetails({});
        } else {
            setStepperDetails({ ...stepperDetails, ...data });
        }
    }


    const updateStepStatus = () => {
        setStepStatus({ 1: 'waiting', 2: 'waiting', 3: 'waiting' });
    };

    const getShippingValue = (value: any) => {
        return value ?? '';
    }

    const getShippingMethodValue = (value: any) => {
        return (value == null || value =="") ? 0 : value;
    }

    const getOrderContactValue = (data : any, isPickupOrAdditionalPickup :any) => {
        const orderContact = {
            id: 0,
            userAdId: getShippingValue(headercurrentuser?.azureADId),
            email: data?.contactEmail ?? headercurrentuser?.eml,
            phoneCountryCode: getShippingValue(isPickupOrAdditionalPickup ? data?.contactPhoneCountryCode : data?.phoneCountryCode),
            phone: getShippingValue(isPickupOrAdditionalPickup ? data?.contactPhone : data?.phone),
            name: getShippingValue(isPickupOrAdditionalPickup ? data?.contactName : data?.attention)
        };
        return orderContact;
    }

    const saveShipmentDetails = async () => {
        try {
            const { isPickup, isPickupAvailable, isPickupWillCallKomatsuShipping } = stepperDetails?.fulfillment ?? {};
            const { isShippingType  } = stepperDetails?.shipment ?? {};
            
            setSaveShipmentDetailsRes({ loading: true, data: {} });
            const data = stepperDetails?.shipment;
            const orderContact = getOrderContactValue(data, (isPickup || isPickupAvailable || isPickupWillCallKomatsuShipping));
            const orderAddress = {
                addressType: 'Shipping',
                firstName: data?.firstName,
                lastName: data?.lastName,
                companyName: globalData?.CustomerName,
                companyId: globalData?.CustomerId,
                address1: data?.address1,
                address2: data?.address2,
                countryCode: data?.countryCode,
                stateCode: data?.stateCode,
                city: data?.city,
                postalCode: data?.postalCode,
                addressId: data?.addressId ?? 0,
                phone: data?.phone,
                phoneCountryCode: data?.phoneCountryCode,
                attention: data?.attention
            };

            const reqBody = {
                cartId: cartsDetails?.cart?.cartId,
                shippingMethodid: getShippingMethodValue(stepperDetails?.shipment?.shippingMethodId),
                serviceTypeId: stepperDetails?.shipment?.serviceTypeId ?? 0,
                orderUserContact: orderContact,
                orderAddress: orderAddress,
                isPickupOnly: !isShippingType
            }

            const response = await partsService.saveShipmentDetails({ userAadId: headercurrentuser?.azureADId, reqBody });
            if (response?.isSuccess) {
                setSaveShipmentDetailsRes({ loading: false, data: response?.data ?? {} });
                setStepStatus({ ...stepStatus, 1: 'finished' });
                getItemSummaryDetailsWithoutLoading();
                return true;
            } else {
                helperfunctions.showErrorMessage(`${response?.msg}`);
                setSaveShipmentDetailsRes({ loading: false, data: {} });
                return false;
            }
        } catch (error) {
            setSaveShipmentDetailsRes({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
            return false;
        }
    }

    const placeOrder = async () => {
        try {
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                userAadId: headercurrentuser?.azureADId ?? '',
                specialInstruction: stepperDetails?.order?.splInstruction ?? ''
            }
            setPlaceOrderRes({ loading: true, data: {} });
            const response = await partsService.placeOrder(reqBody);
            if (response?.isSuccess) {
                setPlaceOrderRes({ loading: false, data: response?.data ?? {} });
                if (!response?.data?.isSuccessful) {
                    helperfunctions.showErrorMessage(`${response?.data?.message}`);
                } else {
                    localStorage.setItem("isOrderPlaced", "true");
                    helperfunctions.scrollToTop();
                    helperfunctions.showSuccessMessage(response?.data?.message);
                }
            } else {
                setPlaceOrderRes({ loading: false, data: {} });
            }
        } catch (error) {
            setPlaceOrderRes({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const clearCartCheckOutData = async (cartId : any = null) => {
        try {

            setClearCartCheckOutDatarRes({ loading: true, data: {} });
            const reqBody = {
                cartId: cartId ?? cartsDetails?.cart?.cartId,
                userAadId: headercurrentuser?.azureADId ?? '',
            }
            const response = await partsService.clearCartCheckOutData(reqBody);
            if (response?.isSuccess) {
                if (!response?.data?.isSuccess) {
                    helperfunctions.showErrorMessage(`${response?.data?.message}`);
                }
                setClearCartCheckOutDatarRes({ loading: false, data: response?.data ?? {} });
            } else {
                setClearCartCheckOutDatarRes({ loading: false, data: {} });
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setClearCartCheckOutDatarRes({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const getWeatherWarning = async (zipcode: any = '', countryCode: any = '') => {
        try {
            if (zipcode.trim()) {
                const response = await partsService.getWeatherWarning(cartsDetails?.cart?.cartId ?? 0, headercurrentuser?.azureADId, zipcode, countryCode.trim());
                if (response?.isSuccess) {
                    return { loading: false, data: response?.data ?? {} };
                } else {
                    helperfunctions.showErrorMessage(`${response?.msg}`);
                    return { loading: false, data: {} };
                }
            } else {
                return { loading: false, data: {} };
            }
        } catch (error) {
            helperfunctions.showErrorMessage(`${error}`);
            return { loading: false, data: {} };
        }
    }

    const savePaymentDetails = async () => {
        try {
            setSavePaymentDetailsRes({ loading: true, data: {} })
            const addressId = stepperDetails?.payment?.addressId;
            let model = {};
            if (stepperDetails?.payment?.paymentMethod?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.KC].toLowerCase()) {
                model = {
                    userAadId: azureADId,
                    cartId: cartsDetails?.cart?.cartId ?? 0,
                    paymentType: stepperDetails?.payment?.paymentMethod ?? '',
                    billingAddress: {
                        addressId: addressId,
                        companyName: globalData?.CustomerName,
                        companyId: globalData?.CustomerId,
                        firstName: stepperDetails?.payment?.firstName,
                        lastName: stepperDetails?.payment?.lastName,
                        address1: stepperDetails?.payment?.address1,
                        address2: stepperDetails?.payment?.address2,
                        city: stepperDetails?.payment?.city,
                        stateCode: stepperDetails?.payment?.stateCode,
                        postalCode: stepperDetails?.payment?.postalCode,
                        countryCode: stepperDetails?.payment?.countryCode,
                        addressType: "Billing",
                    },
                    creditCardProfileId: stepperDetails?.payment?.creditCardProfileId ?? 0,
                    poNumber: stepperDetails?.payment?.poNumber ?? ""
                }
            }
            else {
                model = {
                    userAadId: azureADId,
                    cartId: cartsDetails?.cart?.cartId ?? 0,
                    paymentType: stepperDetails?.payment?.paymentMethod ?? '',
                    poNumber: stepperDetails?.payment?.poNumber ?? ""
                }
            }

            const response = await partsService.savePaymentDetails(model);
            if (response.data?.isSuccessful) {
                setStepStatus({ ...stepStatus, 2: 'finished' })
                setSavePaymentDetailsRes({ loading: false, data: response.data });
                return true;
            }
            else {
                setSavePaymentDetailsRes({ loading: false, data: response.data });
                helperfunctions.showErrorMessage(response.data?.message);
                return false;
            }
        }
        catch (e: any) {
            setSavePaymentDetailsRes({ loading: false, data: {} });
            helperfunctions.showErrorMessage(e);
            return false;
        }
    }

    const getAvailabilityDetails = async (isAvailabilityRefresh: boolean = false) => {
        try {
            setAvailabilityDetails({ loading: true, data: {} });
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                userAadId: azureADId
            }
            const response = await partsService.getAvailabilityDetails(reqBody);
            if (isAvailabilityRefresh) {
                dispatchsetGlobalData({ isAvailabilityRefresh: false });
            }

            if (response?.isSuccess) {
                setAvailabilityDetails({ loading: false, data: response?.data ?? {} });
            } else {
                setAvailabilityDetails({
                    loading: false, data: {}
                });
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setAvailabilityDetails({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    return (
        <ShoppingCart
            updateStepIndex={updateStepIndex}
            productRecommendationPopupClick={productRecommendationPopupClick}
            productRecommendationPopup={productRecommendationPopup}
            toggleManufacturePopupClick={toggleManufacturePopupClick}
            manufacturePopup={manufacturePopup}
            toggleMachinePopupClick={toggleMachinePopupClick}
            isMachine={isMachine}
            onHandlePartNo={onHandlePartNo}
            isPartNumber={isPartNumber}
            cartsDetails={cartsDetails}
            handleParentChange={handleParentChange}
            handleChildChange={handleChildChange}
            childCheckboxes={childCheckboxes}
            handleDeselectAll={handleDeselectAll}
            checkoutOnClick={props.checkoutOnClick}
            onRefresh={onRefresh}
            manufactureOption={manufactureOption}
            machineOption={machineOption}
            getCartItems={getCartItems}
            partNumberRedirect={partNumberRedirect}
            setCartDetails={setCartDetails}
            updateCartQuantity={updateCartQuantity}
            machineManufactureModel={machineManufactureModel}
            setMachineManufactureModel={setMachineManufactureModel}
            maintenancePartsList={maintenancePartsList}
            setMaintenancePartModel={setMaintenancePartModel}
            setMaintenancePartSerial={setMaintenancePartSerial}
            setMaintenancePartsList={setMaintenancePartsList}
            updateCartItem={updateCartItem}
            cartItem={cartItem}
            partsListItems={partsListItems}
            setSelectedBookmarkItem={setSelectedBookmarkItem}
            selectedBookmarkItem={selectedBookmarkItem}
            getBookmarkItems={getBookmarkItems}
            getPartsListItemsForGrid={getPartsListItemsForGrid}
            getPartsListItems={getPartsListItems}
            bookmarkItems={bookmarkItems}
            partsListItemsGrid={partsListItemsGrid}
            setListType={setListType}
            listType={listType}
            setBookmarkItems={setBookmarkItems}
            setPartsListItemsGrid={setPartsListItemsGrid}
            isFetchingCartItems={isFetchingCartItems}
            setIsMaintenancePartLoading={setIsMaintenancePartLoading}
            isMaintenancePartLoading={isMaintenancePartLoading}
            itemSummaryDetails={itemSummaryDetails}
            getItemSummaryDetails={getItemSummaryDetails}
            deletePartNumbers={deletePartNumbers}
            getIsNextDisableStatus={getIsNextDisableStatus}
            isDisableNext={isDisableNext}
            currentStep={currentStep}
            updateStepperDetails={updateStepperDetails}
            stepperDetails={stepperDetails}
            openSavePartList={openSavePartList}
            setRefreshCartRequiredParts={setRefreshCartRequiredParts}
            refreshCartRequiredParts={refreshCartRequiredParts}
            quantityChange={quantityChange}
            saveShipmentDetails={saveShipmentDetails}
            saveShipmentDetailsRes={saveShipmentDetailsRes}
            placeOrder={placeOrder}
            placeOrderRes={placeOrderRes}
            isRefreshing={isRefreshing}
            isFetchingPartsListItems={isFetchingPartsListItems}
            savePaymentDetails={savePaymentDetails}
            savePaymentDetailsRes={savePaymentDetailsRes}
            fulfillmentDetailRes={fulfillmentDetailRes}
            savedAddressRes={savedAddressRes}
            shippingMethodsRes={shippingMethodsRes}
            paymentInfoRes={paymentInfoRes}
            isPunchOutUser={isPunchOutUser}
            clearCartCheckOutData={clearCartCheckOutData}
            clearCartCheckOutDatarRes={clearCartCheckOutDatarRes}
            isPunchOutDistributorUser={isPunchOutDistributorUser}
            updateStepStatus={updateStepStatus}
            isPlaceOrderButton={isPlaceOrderButton}
            getAvailabilityDetails={getAvailabilityDetails}
            availabilityDetails={availabilityDetails}
            customerCreditInfo={customerCreditInfo}
            getCustomerCreditInfo={getCustomerCreditInfo}
            updateIsPartAddedStatus={updateIsPartAddedStatus}
            isPartAdded={isPartAdded}
            page={props.page}
            setPlaceOrderRes={setPlaceOrderRes}
            getItemSummaryDetailsWithoutLoading={getItemSummaryDetailsWithoutLoading}
            updateStepOne={updateStepOne}
            getMaintenancePartsList={getMaintenancePartsList}
            cartToolMenu={cartToolMenu}
            setcartToolMenu={setcartToolMenu}
            isStepOneLoadingCompleted={isStepOneLoadingCompleted}
            setManufactureOption={setManufactureOption}
            isShowReturnable={showReturnableFlag}
            enableOrderTracking={enableOrderTracking}
            miningParts={miningParts}
            getMiningParts={getMiningParts}
            getAdminFlag={getAdminFlag}
            isNewPartAdded={isNewPartAdded}
            punchoutButtonVisibility={punchoutButtonVisibility}
            isDropshipEnable={isDropshipEnable}
            mvcPunchoutHistoryUrl={mvcPunchoutHistoryUrl}
            distributorContactsInfo={distributorContactsInfo}
            setShowCreditWarningMsg={setShowCreditWarningMsg}
            isCartListLoading={isCartListLoading}
            setIsRefreshing={setIsRefreshing}
            getMachineManufacturePunchoutButton={getMachineManufacturePunchoutButton}
            clearMachineManufacturePunchoutButton={clearMachineManufacturePunchoutButton}
            komatsuCreditHistoryButtonVisibility={komatsuCreditHistoryButtonVisibility}
        />
    );
}

export default ShoppingCartContainer;